import { render, staticRenderFns } from "./DocumentManageEdit.vue?vue&type=template&id=ce9b1c2a&"
import script from "./DocumentManageEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentManageEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocumentManageEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports